import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Breadcrumbs from 'components/Breadcrumbs';
import DashboardFlightsCard from 'components/DashboardFlightsCard';
import DashboardSkeleton from 'components/DashboardSkeleton';

import { withData } from 'lib';
import { DashboardQuery } from '__generated__/DashboardQuery.graphql';

const query = graphql`
  query DashboardQuery {
    dashboardFlights {
      ...DashboardFlightsCard_flightsInfo
    }

    settings {
      ...DashboardFlightsCard_settings
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<DashboardQuery>;
};

const Dashboard: FC<Props> = ({ preloadedQuery }) => {
  const { dashboardFlights, settings } = usePreloadedQuery<DashboardQuery>(
    query,
    preloadedQuery
  );

  return (
    <Box>
      <Breadcrumbs breadcrumbs={[]} />

      <Grid container spacing={2}>
        <DashboardFlightsCard
          flightsInfo={dashboardFlights}
          settings={settings}
        />
      </Grid>
    </Box>
  );
};

export default withData<DashboardQuery>({
  query,
  loading: <DashboardSkeleton />,
})(Dashboard);
